import OTilesModalSK from './o-tiles-modal-sk';

export default OTilesModalSK;